module.exports = "https://portperrypedals.ca/_res/img/surgeon-group.67f475c.png";